import script from "./PaginationRow.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginationRow.vue?vue&type=script&setup=true&lang=js"

import "./PaginationRow.vue?vue&type=style&index=0&id=35a48925&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/mayesh.com/httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35a48925"]])

export default __exports__